package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.features.service.ui.addeditservice.EditServiceSectionData
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.dropdown.EsSearchableDropDown
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberFind

@Composable
internal fun CategorySectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
    validation: AddEditServiceValidation,
) {
    val category = rememberFind(
        state.getAllCategory.data.orEmpty(),
        state.service.value.category,
    ) { cat -> cat.id }

    Spacer(modifier = Modifier.height(2.spacing))
    EsSearchableDropDown(
        itemList = state.getAllCategory.data.orEmpty().sortedBy { it.name },
        isLoading = state.getAllCategory.isLoading,
        itemName = category?.name ?: "",
        findItem = { foundCategory, searchText ->
            foundCategory.name.contains(searchText, ignoreCase = true)
        },
        emptyListText = "No categories found!",
        placeholder = "Select category",
        state = validation.addEditServiceForm.category.state,
        message = "This field is required",
        label = "Category",
        enabled = enabled,
        modifier = Modifier.width(400.dp),
        content = { focusManager, isDropDownExpanded, filteredList ->
            filteredList.forEach { categoryItem ->
                key(categoryItem.id) {
                    Box(
                        modifier =
                        Modifier
                            .height(40.dp),
                    ) {
                        EsDropdownMenuItem(
                            text = categoryItem.name,
                            onClick = {
                                validation.addEditServiceForm.category.validate(categoryItem.id)
                                onEvent(
                                    AddEditServiceEvent.UpdateServiceFields(
                                        state.service.value.copy(
                                            category = categoryItem.id,
                                        ),
                                    ),
                                )
                                isDropDownExpanded.value = false
                                focusManager.clearFocus()
                            },
                            modifier = Modifier.fillMaxHeight(),
                        )
                    }
                }
            }
        },
    )
}
